import { createTheme } from "@mui/material/styles";
import theme from "./index";
import typography from "./typography";

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: theme.lightMode.primaryOrange,
      contrastText: "#fafafa"
    },
    secondary: {
      light: "#5c0fd9",
      main: "#5c0fd9",
      dark: "#5c0fd9"
    },
    action: {
      disabledBackground: theme.lightMode.primaryOrange,
      disabled: theme.lightMode.white50
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: theme.lightMode.backgroundColor
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px 0px 8px 8px",
          textTransform: "none",
          padding: "0.75rem 2.5rem",
          fontSize: "1rem",
          lineHeight: "1.5"
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: {
          color: theme.lightMode.primaryOrange
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: theme.lightMode.inputError
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: '0px',
          '&.Mui-expanded': {
            margin: '0px',
          },
        },
        root: {
          '&.Mui-expanded': {
            minHeight: '48px'
          },
        },
      },
    },
  },
  typography
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      light: "#FFFFFF",
      main: "#FFFFFF",
      dark: "#FFFFFF"
    },
    secondary: {
      light: "#000000",
      main: "#000000",
      dark: "#000000"
    },
    background: {
      default: "#121212",
      paper: "#121212"
    },
    text: {
      primary: "#fff"
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: "#ffffb3"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#f2f2f2"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px 0px 8px 8px",
          textTransform: "none",
          padding: "0.75rem 2.5rem",
          fontSize: "1rem",
          lineHeight: "1.5"
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px transparent inset",
            backgroundClip: "text"
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.lightMode.primaryWhite
          },
          "& .Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.lightMode.primaryWhite
          },
          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.lightMode.primaryWhite
          },
          "& .MuiInputLabel-root": {
            color: theme.lightMode.primaryWhite
          },
          "& .MuiFormLabel-root": {
            color: theme.lightMode.primaryWhite
          },
          "& .Mui-error": {
            color: theme.lightMode.primaryWhite
          },
          error: {
            borderColor: theme.lightMode.primaryWhite,
            color: theme.lightMode.primaryWhite
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.lightMode.primaryWhite
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: theme.lightMode.primaryWhite
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: theme.lightMode.primaryWhite
          }
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: '0px',
          '&.Mui-expanded': {
            margin: '0px',
          },
        },
        root: {
          '&.Mui-expanded': {
            minHeight: '48px'
          },
        },
      },
    },
  },
  typography
});
